





























































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField, CSelect, CEditDialog},
})
export default class VeneerEquipmentProcessProductivitiesEditDialog extends Mixins(EditDialogMixin) {}
